import { useState, useEffect } from "react";
import axios from "axios";

function SelectEodStep({ onNext, site, url, onBack }) {
  const [eods, setEods] = useState([]);
  const [selectedEods, setSelectedEods] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const pageSize = 20;

  useEffect(async () => {
    setIsLoading(true);
    const params = { siteId: site.siteId, isWithSubmitted: false };
    await axios
      .post(`${url}/coupons/getEods`, params)
      .then((res) => {
        setEods(res.data);
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("Fetch error", error);
        setIsLoading(false)
      });
  }, []);

  const getStatusClass = (firstSaleTime) => {
    const age = (Date.now() - new Date(firstSaleTime)) / (1000 * 60 * 60 * 24);
    if (age > 7) return "red";
    if (age > 5) return "orange";
    return "green";
  };

  const pagedEods = eods.slice((page - 1) * pageSize, page * pageSize);

  const handleRowClick = (eodId) => {
    setSelectedEods((prevSelected) => {
      if (prevSelected.includes(eodId)) {
        return prevSelected.filter((id) => id !== eodId);
      } else {
        return [...prevSelected, eodId];
      }
    });
  };

  const handleNext = () => {
    onNext(selectedEods);
  };

  if(isLoading) return <p>Loading...</p>
  return (
    <div className="menzies-wizard">
      {eods.length > 0 ? (
        <div>
          <div className="header-row">
            <button className="btn" onClick={onBack}>
              ← Back
            </button>
            <h2>Step 1: Select EOD</h2>
          </div>
          <table>
            <thead>
              <tr>
                <th>EOD ID</th>
                <th>First Sale</th>
                <th>Barcodes</th>
                <th>Sales</th>
                <th>Submitted</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {pagedEods.map((eod) => {
                const isSelected = selectedEods.includes(eod.eodId);
                return (
                  <tr
                    key={eod.eodId}
                    onClick={() => handleRowClick(eod.eodId)}
                    className={isSelected ? "selected-row" : "unselected-row"}
                  >
                    <td>{eod.eodId}</td>
                    <td>{new Date(eod.firstSaleTime).toLocaleString()}</td>
                    <td>{eod.barcodeCount}</td>
                    <td>{eod.saleCount}</td>
                    <td>{new Date(eod.dateSubmitted).toLocaleDateString()}</td>
                    <td>
                      <span
                        className={`status-${getStatusClass(
                          eod.firstSaleTime
                        )}`}
                      >
                        {getStatusClass(eod.firstSaleTime).toUpperCase()}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div
            className="button-group"
            style={{ justifyContent: "center", marginTop: "1rem" }}
          >
            <button
              className="btn"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
            <span style={{ margin: "0 1rem" }}>
              Page {page} of {Math.ceil(eods.length / pageSize)}
            </span>
            <button
              className="btn"
              onClick={() => setPage(page + 1)}
              disabled={page * pageSize >= eods.length}
            >
              Next
            </button>
          </div>
          {selectedEods.length > 0 && (
            <button className="btn btn-success" onClick={handleNext}>
              Next Step
            </button>
          )}
        </div>
      ) : (
        <div>
          <div className="header-row">
            <button className="btn" onClick={onBack}>
              ← Back
            </button>
          </div>
          <h2>No data</h2>
        </div>
      )}
    </div>
  );
}
export default SelectEodStep;
